import { render, staticRenderFns } from "./TicketBox.vue?vue&type=template&id=f43fdf2c&scoped=true"
import script from "./TicketBox.vue?vue&type=script&lang=js"
export * from "./TicketBox.vue?vue&type=script&lang=js"
import style0 from "./TicketBox.vue?vue&type=style&index=0&id=f43fdf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43fdf2c",
  null
  
)

export default component.exports